// side effect: store configuration, when decisions are made
import Cookies from 'js-cookie';
import {msg, str} from '@lit/localize';
import {clearAccount, storeAccount} from '../slices/accountSlice';
import {clearCurrentProfile, getProfile, setCurrentProfileId} from '../slices/profileSlice';
import {clearArtworks} from '../slices/artworkSlice';
import {navigateTo, showMessage} from '../slices/statusSlice';

export const accountMiddleware = store => next => async action => {
	const result = next(action);

	// store
	if (action.type === 'account/setEmail') {
		store.dispatch(storeAccount());
	}

	// load full main profile data after login/init
	if (action.type === 'account/initSession/fulfilled' || action.type === 'account/authenticateWithToken/fulfilled') {
		const state = store.getState();
		if (state.account.data?.loggedIn) {
			if (state.account.data?.account?.mainProfile) {
				store.dispatch(setCurrentProfileId(state.account.data?.account?.mainProfile.id));
				//store.dispatch(navigateTo({route: 'artworks', params: {language: state.status.lang, id: state.account.data?.account?.mainProfile.id}}));
			} else {
				// get saved profileId from cookie
				// Todo: check permissions
				const profileId = Cookies.get('arc-profile');
				if (profileId) {
					store.dispatch(setCurrentProfileId(profileId));
					//store.dispatch(navigateTo({route: 'artworks', params: {language: state.status.lang, id: profileId}}));
				}
			}
		}
	}

	//
	if (action.type === 'account/loginWithEmail/fulfilled') {
		if (!(action.payload?.status === 422)) {
			store.dispatch(showMessage({
				message: msg(str`login code sent to ${action.meta.arg.email}`),
				messageType: 'success'
			}));
			store.dispatch(navigateTo({route: 'login', params: {language: store.getState().status.lang}}));
		} else {
			store.dispatch(showMessage({
				message: msg(str`login code could not be sent`),
				messageType: 'error'
			}));
		}
	}

	if (action.type === 'account/signup/fulfilled') {
		if (!(action.payload?.status === 422)) {
			store.dispatch(showMessage({
				message: msg(str`login code sent to ${action.meta.arg.email}`),
				messageType: 'success'
			}));
			store.dispatch(navigateTo({route: 'login', params: {language: store.getState().status.lang}}));
		} else {
			store.dispatch(showMessage({
				message: msg(str`Signup not possible. Do you already have an account?`),
				messageType: 'error'
			}));
		}
	}

	// clear data after logging out
	if (action.type === 'account/logout/fulfilled') {
		store.dispatch(clearCurrentProfile());
		store.dispatch(clearArtworks());
	}

	// if any action ends with /rejected, check if it's 'Unauthorized' and redirect to login
	if (action.type.endsWith('/rejected')) {
		const state = store.getState();
		if (action.error.message === 'Unauthorized') {
			console.log('Unauthorized');
			store.dispatch(clearCurrentProfile());
			store.dispatch(clearArtworks());
			store.dispatch(clearAccount());
		}
	}

	return result;
};
